import PropTypes from 'prop-types';
import { Button } from '@evertrue/et-components';

const GlobalSearchDropdownHeader = ({ label = '', total, handleGlobalSearch = () => {} }) => {
  const displayText =
    total === 1 ? `View ${label.toLowerCase().slice(0, -1)} result` : `View all ${label.toLowerCase()} results`;

  return (
    <div className="clearfix">
      <strong className="pull-left">{label}</strong>
      <Button
        type="simple"
        className="pull-right global-search--view-all"
        title="View results"
        onClick={handleGlobalSearch}
      >
        {displayText}
      </Button>
    </div>
  );
};

export default GlobalSearchDropdownHeader;

GlobalSearchDropdownHeader.propTypes = {
  label: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  handleGlobalSearch: PropTypes.func.isRequired,
};
